import ContextCard from '@/components/ContextCard/ContextCard'
import { useScheduleStart } from '@/features/chat/phase1/useScheduleStart'
import { useScheduleDetailsOptional } from '@/features/scheduleDetails/useScheduleDetails'
import AutomationCardError from './AutomationCardError'
import AutomationCardInner from './AutomationCardInner'

const NOTE = {
  draft: 'Saved as a draft — it will not run until you start it.',
  started: 'Started. It will run on this schedule.',
  discarded: 'Discarded.',
}

export default function AutomationCardBlock({ block }) {
  const { status, error, pending, act } = useScheduleStart(block)
  const schedule = useScheduleDetailsOptional()
  if (block.status === 'invalid') return <AutomationCardError error={block.error} />
  const issue = Boolean(error) || status === 'discarded'
  const onOpen =
    schedule && block.workflow_id
      ? () => schedule.openSchedule({ id: block.workflow_id, objectType: 'workflow' })
      : null
  return (
    <ContextCard activity={issue ? 'automation' : 'success'} title="Created automation" plain medium>
      <AutomationCardInner
        block={block}
        status={status}
        error={error}
        pending={pending}
        act={act}
        note={NOTE[status]}
        onOpen={onOpen}
      />
    </ContextCard>
  )
}
